<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <div class="col-xl-3">
        <BranchStatsPanel />
      </div>
      <!-- end col -->
      <div class="col-xl-9">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create Branch</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CreateBranchForm></CreateBranchForm>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Create Branch Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Create Branch",
    meta: [{ name: "Create Branch", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "Create Branch",
      items: [
        {
          text: "Branch",
          href: "/"
        },
        {
          text: "Create Branch",
          active: true
        }
      ]
    };
  }
};
</script>
